import BaseService from "./_base.service";
import { History } from "../models/history";

const endpoint = "shipment/histories";

const ShipmentHistoryService = {
  ...BaseService<History>({ endpoint }),
};

export default ShipmentHistoryService;
